// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1QLOn","options":"AnswerScale_options__2jsmq","selected":"AnswerScale_selected__2q9VI"};